import dynamic from 'next/dynamic';
import type { PlaceholderType } from './types';
import { PlaceholderTypes } from './types';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../interfaces';

const DynamicComponentContactForm = dynamic(
  () => import(/* webpackChunkName: 'CMS_ContactForm' */ '../Forms/Contact/ContactForm'),
);
const DynamicComponentRevocationForm = dynamic(
  () => import(/* webpackChunkName: 'CMS_RevocationForm' */ '../Forms/Revocation/RevocationForm'),
);
const DynamicRateProtectionForm = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_RateProtectionForm' */ '../Forms/RateProtection/RateProtectionForm'
    ),
);

export const Placeholder = ({ data }: { data: PlaceholderType }) => {
  const { field_placeholder_variants: variant } = data;

  switch (variant) {
    case PlaceholderTypes.ContactForm:
      return <DynamicComponentContactForm />;
    case PlaceholderTypes.RevocationForm:
      return <DynamicComponentRevocationForm />;
    case PlaceholderTypes.RateProtectionType:
      return <DynamicRateProtectionForm />;
    default:
      return <div data-testid="placeholder-not-found" />;
  }
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.Placeholder]: Placeholder });
